import React, {useContext} from 'react';
import {Context} from '../../context';
import Button from '../UI/Button';
import {Link} from 'react-router-dom';

function MigrationSuccessful(props) {
  const {accountLockedAfterTransfer} = props;
  const {localeText} = useContext(Context);
  return (
    <div className='flex flex-col items-center w-full'>
      <p className='text-4xl mt-0'>
        {localeText('rw_title_migration_successful', 'Migration Successful!')}
      </p>
      <div className='md:w-4/5 xl:w-2/3 2xl:w-1/2'>
        <ul className='list-disc ml-10'>
          <li>
            {localeText(
              'rw_msg_migration_note_1',
              'Remaining stored value balances, from all the cards associated with your previous account, have been transferred into your new transit account.'
            )}
          </li>
          <li>
            {localeText(
              'rw_msg_migration_note_2',
              'You will need to download the SunRail Mobile App or obtain new SunCards to access your passes and stored values.'
            )}
          </li>
          <li>
            {localeText(
              'rw_msg_migration_note_3',
              'All unexpired passes (Weekly, Monthly, and Annual) on your previous SunCards have been transferred to your new account.'
            )}
          </li>
          <li>
            {localeText(
              'rw_msg_migration_note_4',
              'You will need to reassign unexpired passes to your new SunCards or use them in the Mobile App.'
            )}
          </li>
        </ul>
      </div>
      {accountLockedAfterTransfer && (
        <div className='text-red text-xl my-4'>
          {localeText(
            'rw_msg_account_locked',
            'We’re sorry, this account is currently locked. Please contact customer support at 1-855-RAIL-411 (1-855-724-5411) or at info@sunrail.com.'
          )}
        </div>
      )}
      <Link className='mt-10' to='/'>
        <Button className='w-96 mr-4'>
          {localeText('rw_button_return_to_acc', 'Return to Account')}
        </Button>
      </Link>
    </div>
  );
}

export default MigrationSuccessful;
